import { render } from "./CalendarView.vue?vue&type=template&id=ba42d94c&scoped=true"
import script from "./CalendarView.vue?vue&type=script&lang=ts"
export * from "./CalendarView.vue?vue&type=script&lang=ts"

import "./CalendarView.vue?vue&type=style&index=0&id=ba42d94c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ba42d94c"

export default script